export interface IntegrationMetadata {
  name: string;
  description: string;
  logoUrl: string;
  isAvailableToPublic: boolean;
}

export const INTEGRATION_METADATA: Record<string, IntegrationMetadata> = {
  'Microsoft Teams': {
    name: 'Microsoft Teams',
    description: 'Collaborate with your team through chat, meetings, and file sharing.',
    logoUrl: '/integration-logos/microsoft-teams.svg',
    isAvailableToPublic: false,
  },
  Lattice: {
    name: 'Lattice',
    description: 'Performance management and employee engagement platform.',
    logoUrl: '/integration-logos/lattice.svg',
    isAvailableToPublic: false,
  },
  BambooHR: {
    name: 'BambooHR',
    description: 'HR software for managing employee data and HR processes.',
    logoUrl: '/integration-logos/bamboohr.svg',
    isAvailableToPublic: false,
  },
  Workday: {
    name: 'Workday',
    description: 'Cloud-based finance and HR management system.',
    logoUrl: '/integration-logos/workday.svg',
    isAvailableToPublic: false,
  },
  ADP: {
    name: 'ADP',
    description: 'Payroll, HR, and tax filing solutions for businesses.',
    logoUrl: '/integration-logos/adp.svg',
    isAvailableToPublic: false,
  },
  Asana: {
    name: 'Asana',
    description: 'Work management platform for teams to organize and track projects.',
    logoUrl: '/integration-logos/asana.svg',
    isAvailableToPublic: false,
  },
  'Monday.com': {
    name: 'Monday.com',
    description: 'Work OS that powers teams to run processes and workflows.',
    logoUrl: '/integration-logos/monday.svg',
    isAvailableToPublic: false,
  },
  Linear: {
    name: 'Linear',
    description: 'Issue tracking tool designed for high-performance teams.',
    logoUrl: '/integration-logos/linear.svg',
    isAvailableToPublic: true,
  },
  Jira: {
    name: 'Jira',
    description: 'Project management tool for agile software development teams.',
    logoUrl: '/integration-logos/jira.svg',
    isAvailableToPublic: true,
  },
  ClickUp: {
    name: 'ClickUp',
    description: 'All-in-one project management and productivity platform.',
    logoUrl: '/integration-logos/clickup.svg',
    isAvailableToPublic: true,
  },
  GitHub: {
    name: 'GitHub',
    description: 'Development platform for version control and collaboration on code.',
    logoUrl: '/integration-logos/github.svg',
    isAvailableToPublic: true,
  },
  Mattermost: {
    name: 'Mattermost',
    description: 'Open-source, self-hostable online chat service with file sharing.',
    logoUrl: '/integration-logos/mattermost.svg',
    isAvailableToPublic: false,
  },
  Slack: {
    name: 'Slack',
    description: 'Business communication platform for team collaboration.',
    logoUrl: '/integration-logos/slack.svg',
    isAvailableToPublic: true,
  },
  Telegram: {
    name: 'Telegram',
    description: 'Cloud-based messaging app with a focus on security and speed.',
    logoUrl: '/integration-logos/telegram.svg',
    isAvailableToPublic: false,
  },
  Discord: {
    name: 'Discord',
    description: 'Voice, video, and text communication service for communities.',
    logoUrl: '/integration-logos/discord.svg',
    isAvailableToPublic: false,
  },
  WhatsApp: {
    name: 'WhatsApp',
    description: 'Messaging app for secure and private communication.',
    logoUrl: '/integration-logos/whatsapp.svg',
    isAvailableToPublic: false,
  },
};

export const getIntegrationMetadata = (integrationType: string): IntegrationMetadata | undefined => {
  return INTEGRATION_METADATA[integrationType];
};

export const getIntegrationLogoUrl = (integrationType: string): string => {
  return (
    INTEGRATION_METADATA[integrationType]?.logoUrl ||
    `/integration-logos/${integrationType.toLowerCase()}.svg`
  );
};

export const getIntegrationDescription = (integrationType: string): string => {
  return (
    INTEGRATION_METADATA[integrationType]?.description || 'Integration for managing work and collaboration.'
  );
};
